import { blockExplorerServer } from "..";
import { API } from "../class";
import joi from "joi";

export const getCoinBalanceAPI = new API<
  // REQUEST_TYPE
  {
    query: {
      address: string;
      microChainId: number;
    };
  },
  // RESPONSE_TYPE
  {
    balance: string;
  },
  // PARSED_RESPONSE_TYPE
  string
>({
  serverInstance: blockExplorerServer,
  url: "/v2/block-explorer/wallets/coins/balance",
  method: "get",
  requestValidator: joi.object({
    query: joi.object({
      address: joi.string().required(),
      microChainId: joi.number().required(),
    }),
  }),
  responseParser: (response: { balance: string }): string => response.balance,
});
